/**
 * Utility functions for text manipulation.
 */

/**
 * Removes emojis from a string.
 * 
 * @param {string} text - The text to clean.
 * @return {string} - The cleaned text.
 */
export const stripEmojis = (text) => {
    if (!text) return "";
    return text.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E6}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F3FB}-\u{1F3FF}\u{1F170}-\u{1F251}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F19A}\u{2B1B}\u{2B1C}\u{2B50}\u{2B55}\u{3030}\u{303D}\u{3297}\u{3299}\u{E000}-\u{F8FF}\u{FE0F}]/gu, '').trim();
};
